var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.175 6.526h-1.701v-1.7A.827.827 0 0 0 16.648 4h-.025a.828.828 0 0 0-.834.825v1.701h-1.692a.84.84 0 0 0-.834.826v.025c0 .463.37.834.834.834h1.693v1.692c0 .455.37.834.833.825h.025c.455 0 .826-.37.826-.825V8.211h1.7A.827.827 0 0 0 20 7.385v-.033a.827.827 0 0 0-.825-.826Zm-4.228 3.377v-.85h-.85c-.447 0-.867-.177-1.188-.489a1.713 1.713 0 0 1-.488-1.212c0-.304.084-.581.227-.826H5.684A1.69 1.69 0 0 0 4 8.211v10.105A1.69 1.69 0 0 0 5.684 20H15.79a1.69 1.69 0 0 0 1.685-1.684v-6.973a1.726 1.726 0 0 1-.86.236 1.684 1.684 0 0 1-1.667-1.676Zm-.033 8.413H6.526a.42.42 0 0 1-.337-.674l1.668-2.215a.426.426 0 0 1 .69.017l1.348 2.03 2.198-2.93a.42.42 0 0 1 .665-.01l2.484 3.1a.42.42 0 0 1-.328.682Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_image.7125c9ba2a3f915de4202bc2b7280adf.svg";